/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na DHTMLX Scheduler rec_type s informacemi v iCalendar formátu
 */
class DhtmlxToIcalRecTypeFactory {
  /**
   * @param {Class.<DhtmlxToIcalRecType>} DhtmlxToIcalRecType
   * @param {IcalApi} ICAL
   * @param {IcalUtil} icalUtil
   * @param {DhtmlxRecTypeUtil} recTypeUtil
   */
  constructor(DhtmlxToIcalRecType, ICAL, icalUtil, recTypeUtil) {
    this.DhtmlxToIcalRecType = DhtmlxToIcalRecType;
    this.ICAL = ICAL;
    this.icalUtil = icalUtil;
    this.recTypeUtil = recTypeUtil;
  }

  /**
   * @param {DhtmlxEvent} event
   * @returns {DhtmlxToIcalRecType}
   */
  create(event) {
    return new this.DhtmlxToIcalRecType(
      this.ICAL,
      event,
      this.icalUtil,
      this.recTypeUtil
    );
  }
}

export default DhtmlxToIcalRecTypeFactory;
